import { useState } from 'react';
import Snippet from '../../components/Snippet/Snippet';

const Hr = () => {

    const [hr, setHr] = useState({
        color: null,
        size: null,
        width: null,
        style: null,
        position: null
    })
    const helperColor = (e) => {
        setHr(prev => ({ ...prev, color: e }))
    }
    const helperSize = (e) => {
        setHr(prev => ({ ...prev, size: e }))
    }
    const helperWidth = (e) => {
        setHr(prev => ({ ...prev, width: e }))
    }
    const helperStyle = (e) => {
        setHr(prev => ({ ...prev, style: e }))
    }
    const helperPosition = (e) => {
        setHr(prev => ({ ...prev, position: e }))
    }
    let classes = ['hr'];
    for (const key in hr) {
        if (hr[key] !== null) {
            classes.push(hr[key])
        }
    }

    let snip = `<div class="${classes.join(' ')}"></div>`

    return <div className="container fluid pt-2" id="intro">
        <div className="container fluid py-2">
            <p className="text xl"><a href="#intro" className="link">&#128279;</a> Horizontal rules</p>
            <p className="text lg">There are several horizontal rules applied by POKE-CSS, some are different by styling and some by sizes.</p>
        </div>
        <div className="row align-items-center">
            <div className="col md-III">
                <div className="container fluid">
                    <div className="form-group form-row md form-rounded" id="class-selector-group">
                        <div className="form-item">
                            <label>Colors</label>
                            <select onChange={(e) => helperColor(e.target.value)}>
                                <option value="dark">.dark</option>
                                <option value="success">.success</option>
                                <option value="danger">.danger</option>
                                <option value="warning">.warning</option>
                                <option value="primary">.primary</option>
                                <option value="info">.info</option>
                            </select>
                        </div>
                        <div className="form-item">
                            <label>Sizes</label>
                            <select onChange={(e) => helperSize(e.target.value)}>
                                <option value="sm">.sm</option>
                                <option value="md">.md</option>
                                <option value="lg">.lg</option>
                                <option value="xl">.xl</option>
                                <option value="xxl">.xxl</option>
                            </select>
                        </div>
                        <div className="form-item">
                            <label>Widths</label>
                            <select onChange={(e) => helperWidth(e.target.value)}>
                                <option value="short">.short</option>
                                <option value="medium">.medium</option>
                                <option value="wide">.wide</option>
                                <option value="full">.full</option>
                            </select>
                        </div>
                        <div className="form-item">
                            <label>Styles</label>
                            <select onChange={(e) => helperStyle(e.target.value)}>
                                <option value="dashed">.dashed</option>
                                <option value="dotted">.dotted</option>
                                <option value="double">.double</option>
                            </select>
                        </div>
                        <div className="form-item">
                            <label>Position</label>
                            <select onChange={(e) => helperPosition(e.target.value)}>
                                <option value="center">.center</option>
                                <option value="right">.right</option>
                                <option value="left">.left</option>
                            </select>
                        </div>
                    </div>

                </div>


            </div>
            <div className="col md-III">
                <div className="container fluid border-dark p-1">
                    {<div dangerouslySetInnerHTML={{ __html: snip }}></div>}
                </div>
                <div className="container fluid">
                    <Snippet code={snip} language='html' />
                </div>
            </div>

        </div>

    </div>

}

export default Hr